import react from "react";

const ButtonDropdown = ({ label = "", value = "Select option", options = [], className = "form-control form-input", onChange, error = false,  ...props }) => {
    let randForId = "fild-" + Math.random();


//console.log(error)


    // const mapOptions = () => {
    //     return (
    //         options.map((item, index) => {
    //             return (
    //                 <option key={index} value={item.value}>{item.label}</option>
    //             )
    //         })
    //     )
    // }

    // return (
    //     <div>
    //         <label htmlFor={randForId} className="form-label">{label}</label>
    //         <select value={value} id={randForId} className={className} {...props} >
    //             <option>Select option</option>
    //             {mapOptions()}
    //         </select>
    //     </div>
    // )


    const mapOptions = () => {
        return (
            options.map((item, index) => {
                return (
                    <li key={index} ><a className="dropdown-item" style={{cursor: "pointer"}} onClick={() => onChange({target: {name: props.name, value: item.value}})}  value={item.value === null ? '' : item.value} >{item.label}</a></li>
                )
            })
        )
    }

    const firstOption = () => {
        if(label.length > 0){
            return  label;
        }
        if(options.length > 0){
            return options[0].label;
        }
        return "";
    }


    return (
        <div className="dropdown" style={{marginTop: '35px'}}>
            <button className={`btn  dropdown-toggle ${error ? `btn-outline-danger` : `btn-secondary`}`} type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                {error ? <i className="fa-solid fa-triangle-exclamation"></i>  : ''}{' '}{value && value.length > 0 ? value :  firstOption() }
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                {/* <li><a className="dropdown-item" href="#">Select option</a></li> */}
                {mapOptions()}
            </ul>
        </div>
    )
}

export default ButtonDropdown;